<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol option="md" size="12">
        <meta-section>
          <div class="text-right">
            <div class="d-flex flex-row gap-2">
              <!-- <SyncButton :all="true" text="Sinkronkan Semua" @check-sync-tasks="checkSyncTasks()"/>
              <SyncButton :checked="checked" @check-sync-tasks="checkSyncTasks()"/> -->
              <SyncButton :all="true" text="Sinkronkan Semua" />
              <SyncButton :checked="checked" />
              <!-- <button type="button" class="btn btn btn-primary" @click="hitDummySync()">Dummy Sync</button> -->
            </div>
          </div>
        </meta-section>
      </GridCol>
      <GridCol>
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="12">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="getData()" type="text" class="form-control"
                      placeholder="Cari NIP/nama pegawai..." style="border-right: 1px solid #d2d6da!important;" />
                  </InputGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.unitkerja_id"
                      :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Unit Kerja"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.jabatan_id"
                      :list="jabatan.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Jabatan"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.status"
                      :list="[{text: 'Aktif', value: 'active'}, {text: 'Tidak Aktif', value: 'inactive'},]"
                      option-value="value"
                      option-text="text"
                      placeholder="Semua Status"
                    />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>
           
          <ListView tableName="table-pegawai">
            <template v-slot:thead>
              <tr>
                <th scope="col" class="text-center">
                  <input style="width: 1.5rem;height: 1.5rem;" type="checkbox" @click="checkall()"
                    v-model="this.isCheckAll" name="check" id="check">
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Nama
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  NIP
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Unit Kerja
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Jabatan
                </th>
                <th scope="col" colspan="2" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Status
                </th>
                <!-- <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Status Sinkronisasi
                </th> -->
                <th scope="col" class="text-secondary opacity-7">Aksi</th>
              </tr>
            </template>
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="7" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td class="text-center">
                  <input style="width: 1.5rem;height: 1.5rem;" type="checkbox" @change.prevent="checking(item)"
                    name="check" :id="'check_' + index" :checked="this.checked.includes(item.id)">
                </td>
                <td class="font-weight-bold">
                  <router-link :to="{
                    name: 'Master Data Pegawai Detail',
                    params: { id: item?.id ?? 0 },
                  }" data-original-title="Master Data Pegawai Detail">{{ item.name ?? "" }}</router-link>
                </td>
                <td>{{ item.nip ?? "" }}</td>
                <td><div class="column-truncate">{{ item?.unitkerja?.name ?? "" }}</div></td>
                <td><div class="column-truncate">{{ item.jabatan?.name ?? "" }}</div></td>
                <td>
                  <argon-badge v-if="item.status == 'active'" color="success">Aktif</argon-badge>
                  <argon-badge v-else-if="item.status == 'inactive'" color="danger">Non Aktif</argon-badge>
                </td>
                <td>
                  <argon-badge v-if="item.status_sync == 'process sync'" color="info">{{ item.status_sync ?? ""
                  }}</argon-badge>
                  <argon-badge v-if="item.status_sync == 'sync'" color="success">{{ item.status_sync ?? ""
                  }}</argon-badge>
                </td>
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{
                        name: 'Master Data Pegawai Detail',
                        params: { id: item?.id ?? 0 },
                      }" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Master Data Pegawai Detail">Detail</router-link>
                    <button @click="selectMutasi(item)" type="button"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link"
                      data-bs-target="#exampleModal" data-bs-toggle="modal">Mutasikan</button>
                    <router-link :to="{ name: 'Log Aktivitas Pegawai', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Log Aktivitas</router-link>
                    <button @click="getLogMutasi(item.id)" type="button"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link"
                      data-bs-target="#logMutasiModal" data-bs-toggle="modal">Log Mutasi</button>
                    <button @click="getLogSync(item.id)" type="button"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link"
                      data-bs-target="#logSyncModal" data-bs-toggle="modal">Log Sinkronisasi</button>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
            <ArgonPagination :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page"
              @changepage="changePage" @changelimit="changeLimit" />
          </ListView>
           
        </CardComponent>
      </GridCol>
    </GridRow>
    <Modal modalid="logSyncModal" title="Log Sinkronisasi" maxwidth="90%" dismissable>
      <ListViewLogSync :logsync="logsync" />
    </Modal>
    <Modal modalid="logMutasiModal" title="Log Mutasi" maxwidth="90%" dismissable>
      <ListViewLogMutasi :logsync="logmutasi" />
    </Modal>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="saveModal()">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Mutasi Pegawai</h5>
              <button type="button" class="btn-close" style="color: #000;" data-bs-dismiss="modal"
                aria-label="Close"><font-awesome-icon icon="fa-solid fa-xmark" /></button>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column gap-2">
                <div class="row">
                  <GridCol md="6">
                    <div class="d-flex flex-column gap-2">
                      <FormGroup label="NIP">
                        <div class="form-control disabled">{{ mutasiData.nip }}</div>
                      </FormGroup>
                    </div>
                  </GridCol>
                  <GridCol md="6">
                    <div class="d-flex flex-column gap-2">
                      <FormGroup label="Nama">
                        <div class="form-control disabled">{{ mutasiData.name }}</div>
                      </FormGroup>
                    </div>
                  </GridCol>
                  <GridCol md="6">
                    <div class="d-flex flex-column gap-2">
                      <FormGroup label="Unit Kerja Lama">
                        <div class="form-control disabled">{{ mutasiData?.unitkerja?.name ?? "&nbsp;" }}</div>
                      </FormGroup>
                    </div>
                  </GridCol>
                  <GridCol md="6">
                    <div class="d-flex flex-column gap-2">
                      <FormGroup label="Immediate Manager">
                        <div class="form-control disabled">{{ mutasiData?.immediate_supervisor?.name ?? "&nbsp;" }}</div>
                      </FormGroup>
                    </div>
                  </GridCol>
                  <GridCol md="6">
                    <div class="d-flex flex-column gap-2">
                      <FormGroup label="Jabatan Lama">
                        <div class="form-control disabled">{{ mutasiData?.jabatan?.name ?? "&nbsp;" }}</div>
                      </FormGroup>
                    </div>
                  </GridCol>
                  <GridCol md="6">
                    <div class="d-flex flex-column gap-2">
                      <FormGroup label="Direct Supervisor">
                        <div class="form-control disabled">{{ mutasiDataStatic?.leader?.name ?? "&nbsp;" }}</div>
                      </FormGroup>
                    </div>
                  </GridCol>
                  <FormGroup label="Cari Direct Supervisor">
                    <input type="text" name="keyword" id="keyword" class="form-control" @keyup="searchEmployee()"
                      v-model="employeeKeyword">
                  </FormGroup>

                  <div v-if="searchedEmployees.length > 0" class="table-responsive border">
                    <table class="table table-hover m-0">
                      <thead>
                        <tr>
                          <th scope="col">Nama</th>
                          <th scope="col">Jabatan</th>
                          <th scope="col">Unit Kerja</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(employee, index) in searchedEmployees" :key="index" class="border-bottom text-center"
                          style="line-height: 58px;" @click="pilihDirectSupervisor(employee)">
                          <td>
                            {{ employee.name ?? "" }}
                          </td>
                          <td>{{ employee.jabatan?.name ?? "" }}</td>
                          <td>{{ employee.jabatan?.unitkerja?.name ?? "" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <FormGroup label="Direct Supervisor">
                    <div class="form-control">{{ mutasiData?.leader?.name ?? "&nbsp;" }}</div>
                  </FormGroup>
                </div>
                <FormGroup label="Unit Kerja" class="m-0 w-100">
                  <select-form name="unitkerja_id" idinput="unitkerja_id" v-model="mutasiData.unitkerja_id" placeholder="Pilih Unit Kerja" :options="unitkerja.map((item) => {
                    return {
                      text: item.name,
                      value: item.id,
                    };
                  })" />
                </FormGroup>

                <FormGroup label="Jabatan" class="m-0 w-100">
                  <select-form name="jabatan_id" idinput="jabatan_id" v-model="mutasiData.jabatan_id" placeholder="Pilih Jabatan" :options="jabatanMutasi.map((item) => {
                    return {
                      text: item.name,
                      value: item.id,
                    };
                  })" />
                </FormGroup>

                <FormGroup label="Tanggal Mutasi">
                  <VueDatePicker @update:model-value="changeTanggalMutasi" v-model="mutasiData.last_mutation_date"
                    :enable-time-picker="false" max-date="new Date()" />
                </FormGroup>

                <FormGroup label="Periode Aktif">
                  <select-form name="last_active_kpi_id" idinput="last_active_kpi_id" v-model="mutasiData.last_active_kpi_id" placeholder="Tidak Ada" :options="periode.map((item) => {
                    return {
                      text: [dateFormat((item.start ?? '')),dateFormat((item.end ?? ''))].join(' - '),
                      value: item.id,
                    };
                  })" />
                </FormGroup>
              </div>
            </div>
            <div class="modal-footer">
              <ArgonButton type="button" databsdismiss="modal" outline>Batalkan</ArgonButton>
              <ArgonButton type="submit" databsdismiss="modal">Simpan</ArgonButton>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalProcessSync" tabindex="-1" aria-labelledby="modalProcessSyncLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <div class="d-flex flex-column gap-4 px-2 py-8 align-items-center">
              <div class="spinner-border" style="width: 6rem; height: 6rem;" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <p class="m-0 text-center">{{ current_sync_task?.progress?.current || '0' }} dari {{ current_sync_task?.progress?.total || '0' }}  data pegawai sedang dalam proses sinkronisasi</p>
            </div>
            <button
              type="button"
              class="btn btn-primary btn-link w-100 m-0"
              style="background-color: #0385f3"
              data-bs-dismiss="modal"
              @click="dismissModalSync()"
              id="btn-minimize-modal-sync"
            >
              Minimalkan Proses
            </button>
          </div>
        </div>
      </div>
    </div>

    <ProgressSync
      v-if="list_sync_tasks.length > 0 && is_modal_sync === false && current_sync_task?.progress?.total !== undefined"
      :current="current_sync_task?.progress?.current || '0'"
      :total="current_sync_task?.progress?.total || '0'"
      @open-modal-sync="openModalSync()"
    />
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent.vue";
import EmployeesApi from "@/repository/api/EmployeesApi";
import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import InputGroup from "@/components/InputGroup.vue";
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import JabatanApi from '@/repository/api/JabatanApi';
import ListView from '@/components/ListView.vue';
import ArgonButton from "@/components/ArgonButton.vue";
import FormGroup from "@/components/FormGroup.vue";
import SyncButton from "@/components/SyncButton.vue";
import ArgonPagination from "@/components/ArgonPagination.vue";
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import Modal from "@/components/Modal.vue";
import ListViewLogSync from './ListViewLogSync.vue';
import ListViewLogMutasi from './ListViewLogMutasi.vue';
import SelectForm from '@/components/SelectForm.vue';
import LogApi from '@/repository/api/LogApi';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import ProgressSync from '@/components/ProgressSync.vue';

export default {
  name: "tables",
  components: {
    CardComponent,
    ThreeDotsMenu,
    ArgonBadge,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    InputGroup,
    ListView,
    ArgonButton,
    FormGroup,
    SyncButton,
    ArgonPagination,
    Modal,
    ListViewLogSync,
    ListViewLogMutasi,
    SelectForm,
    ModelListSelect,
    ProgressSync,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      single: [],
      params: {
        limit: "",
        jabatan_id: "",
        unitkerja_id: "",
        keyword: "",
        status: "",
        page: 1,
      },
      mutasiData: {},
      mutasiDataStatic: {},
      unitkerja: [],
      jabatan: [],
      jabatanMutasi: [],
      checked: [],
      isCheckAll: false,
      metaData: {},
      logsync: [],
      logmutasi: [],
      periode: [],
      timer_search_employee: null,
      employeeKeyword: "",
      searchedEmployees: [],
      // sync task
      list_sync_tasks: [],
      current_sync_task: {},
      sync_check_interval: null,
      is_modal_sync: false,
      sync_check_tasks_interval: null,
    };
  },
  watch: {
    "employeeKeyword": {
      handler: function () {
        if (this.employeeKeyword == undefined || this.employeeKeyword == "" || this.employeeKeyword.length < 3) {
          this.searchedEmployees = [];
        }
      }
    },
    'params.status': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          await this.getJabatan();
          await this.getData();
        }
      },
      deep: false,
    },
    'params.unitkerja_id': {
      handler: async function () {
        this.params.page = 1;
        this.params.jabatan_id = "";
        await this.getJabatan();
        await this.getData();
      },
      deep: true,
    },
    'params.jabatan_id': {
      handler: async function () {
        this.params.page = 1;
        await this.getData();
      },
      deep: true,
    },
    'mutasiData.unitkerja_id': {
      handler: async function () {
        await this.getJabatanMutasi();
      },
      deep: true,
    },
  },
  methods: {
    selectMutasi(data) {
      this.mutasiData = JSON.parse(JSON.stringify(data));
      this.mutasiDataStatic = JSON.parse(JSON.stringify(data));
    },
    pilihDirectSupervisor(item) {
      // direct
      this.mutasiData.leader = JSON.parse(JSON.stringify(item));
      this.mutasiData.leader_id = this.mutasiData.leader.id;

      // immediate
      if (item?.leader) {
        this.mutasiData.immediate_supervisor = JSON.parse(JSON.stringify(item.leader));
        this.mutasiData.immediate_supervisor_id = this.mutasiData?.immediate_supervisor?.id;
      }

      this.employeeKeyword = "";
      this.searchedEmployees = [];
    },
    async searchEmployee() {
      if (this.employeeKeyword.length > 0) {
        clearTimeout(this.timer_search_employee)
        this.timer_search_employee = setTimeout(async () => {
          await EmployeesApi.getByKeyword(this.employeeKeyword).then((response) => {
            this.searchedEmployees = response.data;
          }).catch(() => {
            this.searchedEmployees = [];
            this.$swal({
              icon: "error",
              title: "Data tidak ditemukan",
            });
          });
        }, 650);
      } else {
        this.searchedEmployees = [];
      }

      // if (this.employeeKeyword.length > 3) {
      //   await EmployeesApi.getByKeyword(this.employeeKeyword).then((response) => {
      //     this.searchedEmployees = response.data;
      //   }).catch(() => {
      //     this.$swal({
      //       icon: "error",
      //       title: "Data tidak ditemukan",
      //     });
      //   });
      // }
    },
    dateFormat(date) {
      date = String(date).split("T")[0]
      return date;
    },
    async getPeriode() {
      await KpiPeriodeApi.get().then((response) => {
        this.periode = response.data
      }).catch(() => {
        this.periode = [];
      });
    },
    async getLogSync(id) {
      await EmployeesApi.getsynchronize({ relate_id: id }).then((response) => {
        this.logsync = response.data;
      }).catch(() => {
        this.logsync = []
      })
    },
    async getLogMutasi() {
      this.$store.state.loading = true;
      let params = {}
      // Object.keys(this.params).forEach(key => {
      //   if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
      //     params[key] = this.params[key];
      //   }
      // });
      params['event'] = 'mutasi';
      await LogApi.user(params).then((response) => {
        this.logmutasi = response.data;
      }).catch(() => {
        this.logmutasi = []
      })
      this.$store.state.loading = false;
    },
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async saveModal() {
      if ((this.mutasiData?.active_kpi?.length ?? 0) > 0) {
        this.$swal({
          icon: "error",
          title: "Terdapat KPI Aktif",
        })
        return false
      }
      this.$swal({
        icon: 'warning',
        title: "Apakah anda yakin ingin memutasi?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await EmployeesApi.update(this.mutasiData.id, {
            jabatan_id: this.mutasiData.jabatan_id,
            last_mutation_date: this.mutasiData.last_mutation_date,
            leader_id: this.mutasiData.leader_id,
          }).then(async () => {
            this.$swal({
              icon: 'success',
              title: "Berhasil",
            });
            await this.getData();
          }).catch((error) => {
            this.$swal({
              icon: 'error',
              title: error?.response?.data?.message ?? "Gagal Menyimpan",
            });
          })
        }
      })
    },
    changeTanggalMutasi(value) {
      // console.log(String(value.getDate()).padStart(2, '0'))
      this.mutasiData.last_mutation_date = [String(value.getFullYear()).padStart(4, '0'), String(value.getMonth() + 1).padStart(2, '0'), String(value.getDate()).padStart(2, '0')].join("-");
    },
    async getJabatanMutasi() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({ unitkerja_id: this.mutasiData.unitkerja_id }).then((response) => {
        this.jabatanMutasi = response.data;
      }).catch(() => {
        this.jabatanMutasi = [];
      })
      this.$store.state.loading = false;
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({ page: 'all' }).then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({ unitkerja_id: this.params.unitkerja_id }).then((response) => {
        this.jabatan = response.data;
      }).catch(() => {
        this.jabatan = [];
      })
      this.$store.state.loading = false;
    },
    async synchronize() {
      this.$store.state.loading = true;
      if (this.checked.length < 1) {
        this.$swal({
          icon: "error",
          title: "Pilih data terlebih dahulu"
        })
      }
      else {
        this.$swal({
          html: "<div class='spinner-border' style='width: 88px;height: 88px;'></div><h2 class='swal2-title' id='swal2-title' style='display: block;'>Proses Sinkronisasi</h2><div class='swal2-html-container' id='swal2-html-container' style='display: block;'>Saat ini data pegawai sedang dalam proses sinkronisasi</div>",
          showConfirmButton: false,
          // title: "Proses Sinkronisasi",
          // text: "Saat ini data pegawai sedang dalam proses sinkronisasi"
        });
        let data = new FormData();
        this.checked.map((item) => {
          data.append('nip', item)
        })
        await EmployeesApi.synchronize(data).then(() => {
          this.$swal({
            icon: "success",
            title: "Proses Sinkronisasi Berhasil",
            text: "Proses sinkronisasi berhasil silakan cek data",
            confirmButtonText: "Lihat Data"
          })
          this.$store.state.syncing = true;
        }).catch(() => {
          this.$swal({
            icon: "error",
            title: "Gagal Terhubung"
          });
          this.$store.state.syncing = false;
        });
        // await EmployeeApi.synchronize(this.checked).then(() => {
        // })
      }
      this.$store.state.loading = false;
    },
    checkall() {
      this.data.map((item) => {
        return item.id;
      }).forEach((item) => {
        if (!this.isCheckAll) {
          if (!this.checked.includes(item)) {
            this.checked.push(item);
          }
        }
        else {
          this.checked = []
        }
      })
    },
    checking(data) {
      if (!this.checked.includes(data.id)) {
        this.checked.push(data.id);
      }
      else {
        this.checked.splice(
          this.checked.findIndex((item) => {
            return item == data.id;
          }), 1
        )
      }
    },
    async getData() {
      this.$store.state.loading = true;
      clearTimeout(this.timer);
      if (this.params.keyword.length <= 0) {
        await this.getDataAll();
      } else if (this.params.keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll();
        }, 1500);
      }
      this.$store.state.loading = false;
    },
    async getDataAll() {
      this.$store.state.loading = true;
      await EmployeesApi.getbyparam(this.params)
        .then((response) => {
          this.data = response.data;
          this.metaData = {
            status: response?.status ?? null,
            message: response?.message ?? null,
            total_item: response?.total_item ?? null,
            per_page: response?.per_page ?? null,
            total_page: response?.total_page ?? null,
            current_page: response?.current_page ?? null,
          }
        }).catch((error) => {
          if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
            this.params.page = this.params.page - 1;
          }
          this.data = [];
          this.metaData = {};
        });
      this.$store.state.loading = false;
    },
    dismissModalSync() {
      this.is_modal_sync = false;
    },
    openModalSync() {
      this.is_modal_sync = true;
    },
    async checkSyncTasks() {
      this.sync_check_tasks_interval = setInterval(async () => {
        await EmployeesApi.checkSyncTasks()
          .then((response) => {
            this.list_sync_tasks = response?.data || [];
            if (this.list_sync_tasks.length > 0 && this.sync_check_interval === null) {
              // clear this check tasks
              this.stopCheckSyncTasks();

              // start check sync
              this.startCheckSync();
            }
          }).catch((error) => {
            console.log(error)
            this.list_sync_tasks = [];
          });

        // if (this.list_sync_tasks.length > 0) {
        //   clearInterval(this.sync_check_tasks_interval);
        //   this.sync_check_tasks_interval = null;
        // }
      }, 3000); // 3s
    },
    async stopCheckSyncTasks() {
      clearInterval(this.sync_check_tasks_interval);
      this.sync_check_tasks_interval = null;
    },
    async checkSyncProgress() {
      if (this.list_sync_tasks?.[0]?.task_id) {
        await EmployeesApi.checkSyncProgress(this.list_sync_tasks?.[0]?.task_id)
          .then((response) => {
            this.current_sync_task = response?.data || {};
            // this.current_sync_task = response || {};

            if (response?.data?.complete === true) {
              this.stopCheckSync();
              this.startCheckSync();
              setTimeout(() => {
                if (this.list_sync_tasks.length === 0) {
                  this.$swal({
                    icon: "success",
                    title: "Proses Sinkronisasi Berhasil",
                    // text: `${this.current_sync_task?.progress?.current} dari ${this.current_sync_task?.progress?.total} berhasil disinkronisasi`,
                    text: `${this.current_sync_task?.progress?.description || '0'} dari ${this.current_sync_task?.progress?.description || '0'} berhasil disinkronisasi`,
                    confirmButtonText: "Tutup",
                  });
                  // this.dismissModalSync();
                  const btn_min_modal_sync = document.getElementById('btn-minimize-modal-sync');
                  if (btn_min_modal_sync) btn_min_modal_sync.click();
                }
              }, 1500);
            }
          }).catch((error) => {
            console.log('error checkSyncProgress()', error)
            this.current_sync_task = {};
          });
      } else {
        this.stopCheckSync();
      }
    },
    async startCheckSync() {
      this.sync_check_interval = setInterval(async () => {
        await this.checkSyncProgress();
      }, 3000); 
    },
    async stopCheckSync(is_check_task = true) {
      clearInterval(this.sync_check_interval);
      this.list_sync_tasks = [];
      // this.current_sync_task = {};
      this.sync_check_interval = null;
      this.is_modal_sync = false;

      if (is_check_task) {
        // start check task again
        this.checkSyncTasks();
      }
    },
    async hitDummySync() {
      let data = new FormData();
      data.append('nip', 'dummy-task');

      await EmployeesApi.synchronize(data)
        .then((res) => {
          console.log('synchronize', res?.data)
          // check progress sync
          
          this.$swal({
              icon: "success",
              title: "Send dummy data",
          })
        }).catch((error) => {
          console.log(error)
        });
        
        // this.checkSyncTasks();
    },
  },
  async mounted() {
    this.checkSyncTasks();
    await this.getData();
    await this.getUnitKerja();
    await this.getPeriode();
  },
  beforeRouteLeave: function(to, from, next) {
    this.stopCheckSync(false);
    // setTimeout(() => {
    //   this.stopCheckSyncTasks();
    // }, 50);
    next();
  }
};
</script>
